import { render, staticRenderFns } from "./UserMessagesIncoming.vue?vue&type=template&id=420b71f2&scoped=true"
import script from "./UserMessagesIncoming.vue?vue&type=script&lang=js"
export * from "./UserMessagesIncoming.vue?vue&type=script&lang=js"
import style0 from "./UserMessagesIncoming.vue?vue&type=style&index=0&id=420b71f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b71f2",
  null
  
)

export default component.exports